import script from "./GamePlayerTerminated.vue?vue&type=script&setup=true&lang=ts"
export * from "./GamePlayerTerminated.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__